import React from "react";
import { PopupButton } from "@typeform/embed-react";

// Il form di candidatura vive su Typeform e si apre in popup sopra la landing page,
// così la candidata non lascia mai il contesto del brand. L'id del form arriva da
// REACT_APP_TYPEFORM_ID, incorporato nel bundle al momento del build.
const TYPEFORM_ID = process.env.REACT_APP_TYPEFORM_ID;

if (!TYPEFORM_ID) {
  // Meglio accorgersene in console che scoprire una CTA morta in produzione.
  console.error(
    "REACT_APP_TYPEFORM_ID non impostata: i bottoni di candidatura sono disattivati."
  );
}

export default function TypeformButton({ className = "", children, testId }) {
  // Senza id configurato il bottone resta visibilmente inerte: è preferibile a uno
  // che sembra funzionare e non apre niente.
  if (!TYPEFORM_ID) {
    return (
      <button
        type="button"
        disabled
        className={`${className} opacity-40 cursor-not-allowed`}
        title="Form non configurato (REACT_APP_TYPEFORM_ID mancante)"
        data-testid={testId}
      >
        {children}
      </button>
    );
  }

  return (
    <PopupButton
      id={TYPEFORM_ID}
      className={className}
      buttonProps={{ "data-testid": testId }}
    >
      {children}
    </PopupButton>
  );
}
